import type { Action } from './types';

// Duplicate entries are weights: movement remains twice as likely as each technique.
const BASE_CHOICES: readonly Action[] = [
  'run',
  'run',
  'jump',
  'jump',
  'rasenshuriken',
  'summon',
  'kawarimi',
  'ramen',
  'sexyjutsu',
];

/** Exclude only the last accepted action, preserving the remaining relative weights. */
export function pickAutonomousAction(
  lastAction: Action | undefined,
  available: { clone: boolean; wallrun: boolean },
  random: () => number = Math.random,
  weightedChoices: readonly Action[] = BASE_CHOICES,
): Action {
  const choices = [...weightedChoices];
  if (available.wallrun) choices.push('wallrun');
  if (available.clone) choices.push('clone');
  const eligible = choices.filter((action) => action !== lastAction);
  // Removing one action still leaves at least six base entries to choose from.
  return eligible[Math.floor(random() * eligible.length)]!;
}
